import { Pipe, PipeTransform } from '@angular/core';
import { MissionRequest } from '../../models/mission/mission-request';

@Pipe({
	name: 'filterFormationByAllFields'
})
export class FilterFormationByAllFieldsPipe implements PipeTransform {
	transform(formations: MissionRequest[], filter: string): MissionRequest[] {
		if (
			!formations ||
			!filter ||
			formations === null ||
			filter === null ||
			filter === ''
		) {
			return formations;
		}

		filter = filter.toLowerCase();
		return formations.filter((missionRequest: any) => {
			const beneficiaireName =
				missionRequest?.beneficiaire?.firstName +
				' ' +
				missionRequest?.beneficiaire?.lastName;
			const employeeName =
				missionRequest?.employee?.firstName +
				' ' +
				missionRequest?.employee?.lastName;
			return (
				employeeName?.toLowerCase().includes(filter) ||
				beneficiaireName.toLowerCase().includes(filter) ||
				missionRequest?.missionType.type.toLowerCase().includes(filter) ||
				//Filtre selon la date au format DD/MM/YYYY
				(
					new Date(missionRequest?.date).getDate().toString().toLowerCase() +
					'/' +
					(new Date(missionRequest?.date).getMonth() + 1 < 10
						? '0' + (new Date(missionRequest?.date).getMonth() + 1).toString()
						: (new Date(missionRequest?.date).getMonth() + 1).toString()
					).toLowerCase() +
					'/' +
					new Date(missionRequest?.date)
						.getFullYear()
						.toString()
						.slice(2)
						.toString()
				).includes(filter) ||
				//Filtre selon l'heure de début au format XXhXX
				(
					(Math.floor(missionRequest?.readyTime / 60) < 10
						? '0' + Math.floor(missionRequest?.readyTime / 60)
						: Math.floor(missionRequest?.readyTime / 60)) +
					'h' +
					(missionRequest?.readyTime % 60 < 10
						? '0' + (missionRequest?.readyTime % 60)
						: missionRequest?.readyTime % 60)
				).includes(filter) ||
				//Heure de fin
				(
					(Math.floor(missionRequest?.dueTime / 60) < 10
						? '0' + Math.floor(missionRequest?.dueTime / 60)
						: Math.floor(missionRequest?.dueTime / 60)) +
					'h' +
					(missionRequest?.dueTime % 60 < 10
						? '0' + (missionRequest?.dueTime % 60)
						: missionRequest?.dueTime % 60)
				).includes(filter) ||
				missionRequest?.missionPlace?.name.toLowerCase().includes(filter) ||
				missionRequest?.careSpecialty?.name.toLowerCase().includes(filter) ||
				missionRequest?.beneficiaire?.careSkill?.name
					.toLowerCase()
					.replaceAll('_', ' ')
					.toString()
					.trim()
					.includes(filter)
			);
		});
	}
}
